export const SET_ORGANISATION_STRUCTURE = "SET_ORGANISATION_STRUCTURE";
export const SET_CITIES = "SET_CITIES";
export const SET_STATES = "SET_STATES";
export const SET_DIVISIONS = "SET_DIVISIONS";
export const SET_SUB_DIVISIONS = "SET_SUB_DIVISIONS";
// export const SET_POSITIONS = "SET_POSITIONS";
export const SET_PROFESSIONS = "SET_PROFESSIONS";
export const SET_SPECIAL_GROUP = "SET_SPECIAL_GROUP";
export const SET_MAINLINE_POSITIONS = "SET_MAINLINE_POSITIONS";
export const SET_DUAL_POSITIONS = "SET_DUAL_POSITIONS";
export const SET_ROLES = "SET_ROLES";
export const SET_APPOINTMENT_POSITIONS = "SET_APPOINTMENT_POSITIONS";
